<template>
  <!-- 多级业务员列表 -->
  <div class="duoJiSalesmanList" >
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['业务员管理', $route.meta.title]">
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px;
          margin-right: 5px"
          clearable
          placeholder="请输入姓名"
        ></el-input>
        <el-button type="primary" 
          icon="el-icon-search"
          @click="getTableData"
          v-if="buttonVisibility.search"
        >搜索</el-button>
        <!-- <el-button type="primary" icon="el-icon-plus" @click="getAddTo">添加</el-button> -->
        <el-button type="danger" @click="handleDel()" :disabled="selectedList.length === 0" v-if="buttonVisibility.delete">删除</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->

    <el-table
      ref="table"
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      row-key="userId"
      @selection-change="selectionChange"
      style="width: 100%"
      :tree-props="{ children: 'Children',hasChildren: 'hasChildren'}"
      :load="loadChildren"
      lazy
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <!-- <el-table-column label="序号" align="center" width="50" type="index"></el-table-column> -->
      <el-table-column prop="userId" label="用户ID" align="center" show-overflow-tooltip min-width="180"></el-table-column>
      <el-table-column prop="name" label="姓名" align="center" show-overflow-tooltip min-width="250">
        <!-- <template slot-scope="scope">
          <span :style="{ paddingLeft: (scope.row._level * 15) + 'px' }">
            <i 
             v-if="scope.row.hasChildren"
              :class="['el-icon-arrow-right', { 'is-expanded': scope.row._expanded }]" 
              @click="toggleExpand(scope.row)"
           />
            {{ scope.row.name }}
          </span>
        </template> -->
      </el-table-column>
      <el-table-column prop="username" label="用户名" align="center" show-overflow-tooltip min-width="180"></el-table-column>
      <el-table-column prop="rankname" label="省代" align="center" show-overflow-tooltip min-width="180"></el-table-column>
      <el-table-column prop="rys" label="人员" align="center" show-overflow-tooltip min-width="180"></el-table-column>
      <el-table-column prop="qnddzs" label="全年单据" align="center" show-overflow-tooltip min-width="180"></el-table-column>
      <el-table-column prop="qnddje" label="全年单据金额" align="center" show-overflow-tooltip min-width="180"></el-table-column>
      <el-table-column prop="dyddzs" label="当月单据数" align="center" show-overflow-tooltip min-width="180"></el-table-column>
      <el-table-column prop="dyddje" label="当月单据金额" align="center" show-overflow-tooltip min-width="180"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="280">
        <template slot-scope="scope">
          <!---->
          <el-button 
            v-if="scope.row.rank !== '5'" 
            type="text" 
            @click="toggleExpand(scope.row)"
          >
            <!-- {{ scope.row._expanded ? '折叠' : '展开' }} -->
          </el-button>
          <!-- 如果row.rank !== '5' 才显示升级按钮 -->
          <el-button 
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getChangeLeader(scope.row)"
            v-if="scope.row.rank !== '5' && scope.row.rank !== '1' && buttonVisibility.changeLeader"
          >更换业务员上级</el-button>
      
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getUpdate(scope.row)"
            v-if="scope.row.rank !== '5' && scope.row.rank !== '1' && buttonVisibility.update"
          >业务员升级</el-button>
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getDown(scope.row)"
            v-if="scope.row.rank !== '5' && scope.row.rank !== '1'  && buttonVisibility.down"
          >业务员降级</el-button>
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getTransfer(scope.row)"
            v-if="scope.row.rank !== '5' && scope.row.rank !== '1'  && buttonVisibility.transfer"
          >迁移下级</el-button>
          <el-button type="primary" style="padding: 2px 3px" plain @click="getBinding(scope.row)" v-if="scope.row.rank !== '5' &&buttonVisibility.bindGoods">绑定商品</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
//表单验证
// import { mustFill } from "@/mixins/data/valid.js";
import { mapState } from 'vuex';


export default {
  name: "duoJiSalesmanList",
  data() {
    return {
      /**表格数据 */
      //序号	单位	用户名	真实姓名	手机号	创建日期	状态	操作
      tableData: [],
      selectedList: [],
      userId: "",
      /**搜索表单 */
      searchForm: {
        name: "",
        Audit: "1",
      },
      PrimaryGrouping_show: false, //分组名称
      PrimaryGrouping: "", //分组名称
      level: "", //分组层级
      parentId: "", //父级

      ModifyPrimaryGrouping_show: false, //修改弹窗
      ModifyPrimaryGrouping: "", //修改名称
      ModifyId: "", //修改code
      rank: "", //业务员等级
      currPage: 1,
      pageSize: 10,
    };
  },
  components: {},
  created() {
    this.getTableData();
  },
  computed: {
    ...mapState(['buttonPermissions']),
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['多级业务员列表'] || [];
      // console.log('lalalalall',buttonsLimit);
      return {
        search: buttonsLimit.includes('搜索'),
        delete: buttonsLimit.includes('删除'),
        update: buttonsLimit.includes('业务员升级'),
        down: buttonsLimit.includes('业务员降级'),
        bindGoods: buttonsLimit.includes('绑定商品'),
        changeLeader: buttonsLimit.includes('更换业务员上级'),
        transfer: buttonsLimit.includes('迁移下级'),
      };
    },
  },
  methods: {
    /**获取多级业务员列表数据 */
    getTableData(num) {
      const jsonData = {
        type: 'manager',
        // managerId: this.userId || '',
        managerId:'',
        rank: '',
        status: '2',
        name: this.searchForm.name,
        pageIndex: this.currPage,
        // pageSize: this.pageSize,
        pageSize:999999,
      };

      let encodedJson = encodeURIComponent(JSON.stringify(jsonData));
      this.currPage = num == 1 ? 1 : this.currPage;
      this.$request({
        url: `/admin/manage/ashx/ReturnJson.ashx?type=ReturnList&json=${encodedJson}&proc=Proc_ManagerRelation`,
        method: "get",
      })
        .then((res) => {
          // console.log('res777', res);
          if(res.data?.[0]?.userId) this.userId = res.data[0].userId;  
          if (res.data && res.data.length > 0) {
         
            this.tableData = (res.data || []).map(item => ({
              ...item,
              hasChildren: ['1', '2', '3'].includes(item.rank),
              _expanded: false // 添加展开状态跟踪
            }));
          } else {
            this.tableData = [];
            this.$message({
              message: "未查询到数据",
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.error("查询错误:", err);
          this.tableData = [];
          this.$message({
            message: "查询失败",
            type: "error",
          });
        });
      },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        row = this.selectedList[0];
        this.getDelete(row);
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    //业务员升级
    getUpdate(row) {
      // console.log('升级row',row);
      this.$confirm("业务员是否升级?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {        
          const jsonData2 = {
            type: 'upgrade',
            managerId: row.userId,
          }      
          let encodedJson2 = encodeURIComponent(JSON.stringify(jsonData2))   
          this.$request({
            method:'get',
            url: `admin/manage/ashx/ReturnJson.ashx?type=ReturnNumber&json=${encodedJson2}&proc=Proc_ManagerRelation`,
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {
          this.$message.info("取消升级业务员！");
        });
    },
     //业务员降级
     getDown(row) {
      this.$confirm("业务员是否降级?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {        
          const jsonData2 = {
            type: 'demote',
            managerId: row.userId,
          }      
          let encodedJson2 = encodeURIComponent(JSON.stringify(jsonData2))   
          this.$request({
            method:'get',
            url: `admin/manage/ashx/ReturnJson.ashx?type=ReturnNumber&json=${encodedJson2}&proc=Proc_ManagerRelation`,
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {
          this.$message.info("取消降级业务员！");
        });
    },
    //绑定商品
    getBinding(row) {
      // console.log('绑定商品row',row);
      const prams = {
        managerId: row.userId,  // 确保包含userId
      };
      // console.log('prams',prams);
      const encoded = btoa(JSON.stringify(prams));
      this.$router.push({
        path: "duoJiSalesBangDingGoods",
        query: {
          prams: encoded,
          timestamp: Date.now()  // 防止缓存
        },
      });
    },
    //更换业务员上级
    getChangeLeader(row) {
      // console.log('更换业务员上级row',row);
      const prams = {
        managerId: row.userId,
      }
      const encoded = btoa(JSON.stringify(prams));
      this.$router.push({
        path: "duoJiSalesChangeLeader",
        query: {
          prams: encoded,
          timestamp: Date.now()  // 防止缓存
        }
      })
    },
    getTransfer(row) {
      const prams = {
        managerId: row.userId,
      }
      const encoded = btoa(JSON.stringify(prams));
      this.$router.push({
        path: "duoJiSalesChangeTransfer",
        query: {
          prams: encoded,
          timestamp: Date.now()  // 防止缓存
        }
      })
    },
    // 加载子级业务员
    async loadChildren(row, treeNode, resolve) {
      if (!(row !== null && row !== void 0 && row.userId)) {
        return resolve([]);
      }

      const jsonData1 = {
        type: 'manager',
        managerId: row.userId,
        rank: row.rank,
        status: '2',
        pageIndex: this.currPage,
        pageSize: 999999,
      };

      try {
        const encodedJson1 = encodeURIComponent(JSON.stringify(jsonData1));
        const res = await this.$request({
          url: `admin/manage/ashx/ReturnJson.ashx?type=ReturnList&json=${encodedJson1}&proc=Proc_ManagerRelation`,
          method: 'get',
        });

        // console.log('子级业务员', res);
        this.userId = res.data[0]?.userId || '';
        const children = (res.data).map(item => ({
          ...item,
          hasChildren: item.rank !== '5',
        }));
        resolve(children);
      } catch (err) {
        console.error(err);
        this.userId = '';
        resolve([]); // 即使出错也调用 resolve
      }
    },
    toggleExpand(row) {
      console.log('row', row);
      this.$refs.table.toggleRowExpansion(row);
    }
  }
};
</script>

<style scoped>
.duoJiSalesmanList {
  width: 100%;
  height: 100%;
}

.zsekl {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
